import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  key: 0,
  "class": "notification"
};
var _hoisted_2 = {
  key: 1
};
var _hoisted_3 = {
  key: 0
};
var _hoisted_4 = {
  key: 1
};
var _hoisted_5 = {
  key: 2
};
var _hoisted_6 = {
  key: 1,
  "class": "edit-h5"
};
var _hoisted_7 = {
  "class": "edit-h5-main"
};
var _hoisted_8 = {
  "class": "edit-h5-header"
};
var _hoisted_9 = {
  "class": "left"
};
var _hoisted_10 = {
  "class": "notification"
};
var _hoisted_11 = {
  key: 1,
  "class": "row"
};
var _hoisted_12 = {
  key: 0,
  "class": "row-p"
};
var _hoisted_13 = {
  key: 1
};
var _hoisted_14 = {
  key: 2,
  "class": "footer"
};
import { nextTick } from "../../../adapter-vue";
import { TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { watchEffect, ref } from "../../../adapter-vue";
import { Toast, TOAST_TYPE } from "../../common/Toast/index";
import { isUniFrameWork } from "../../../utils/env";
export default /*@__PURE__*/_defineComponent({
  __name: 'manage-notification',
  props: {
    data: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    isAuthor: {
      type: Boolean,
      "default": false
    }
  },
  emits: ["update", "close"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var groupProfile = ref({});
    var input = ref("");
    var isAuthorNotification = ref(false);
    var isEdit = ref(false);
    watchEffect(function () {
      groupProfile.value = props.data;
      input.value = groupProfile.value.notification;
      isAuthorNotification.value = props.isAuthor;
    });
    var emits = __emit;
    // 更新群资料
    var updateProfile = function updateProfile() {
      if (input.value.length > 150) {
        Toast({
          message: TUITranslateService.t("TUIGroup.群公告字数超出限制，最大长度为150"),
          type: TOAST_TYPE.ERROR
        });
        return;
      }
      if (input.value && input.value !== groupProfile.value.notification) {
        emits("update", {
          key: "notification",
          value: input.value
        });
        nextTick(function () {
          input.value = "";
        });
      }
      isEdit.value = !isEdit.value;
    };
    var close = function close(tabName) {
      emits("close", tabName);
    };
    return function (_ctx, _cache) {
      return !_unref(isUniFrameWork) ? (_openBlock(), _createElementBlock("main", _hoisted_1, [_unref(isEdit) ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
        key: 0,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(input) ? input.value = $event : null;
        }),
        "class": "textarea",
        onKeyup: _withKeys(updateProfile, ["enter"])
      }, null, 544)), [[_vModelText, _unref(input)]]) : (_openBlock(), _createElementBlock("section", _hoisted_2, [!_unref(groupProfile).notification ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u6682\u65E0\u516C\u544A")), 1)) : (_openBlock(), _createElementBlock("article", _hoisted_4, _toDisplayString(_unref(groupProfile).notification), 1))])), _unref(isAuthorNotification) ? (_openBlock(), _createElementBlock("footer", _hoisted_5, [_unref(isEdit) ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        "class": "btn",
        onClick: updateProfile
      }, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u53D1\u5E03")), 1)) : (_openBlock(), _createElementBlock("button", {
        key: 1,
        "class": "btn",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return isEdit.value = !_unref(isEdit);
        })
      }, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u7F16\u8F91")), 1))])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("main", _hoisted_7, [_createElementVNode("header", _hoisted_8, [_createElementVNode("aside", _hoisted_9, [_createElementVNode("h1", null, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u7FA4\u516C\u544A")), 1)]), _createElementVNode("span", {
        "class": "close",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return close('notification');
        })
      }, _toDisplayString(_unref(TUITranslateService).t("\u5173\u95ED")), 1)]), _createElementVNode("div", _hoisted_10, [_unref(isEdit) ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
        key: 0,
        "class": _normalizeClass([_unref(isUniFrameWork) ? 'uni-height' : '', 'textarea']),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return _isRef(input) ? input.value = $event : null;
        }),
        onKeyup: _withKeys(updateProfile, ["enter"])
      }, null, 34)), [[_vModelText, _unref(input)]]) : (_openBlock(), _createElementBlock("section", _hoisted_11, [!_unref(groupProfile).notification ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u6682\u65E0\u516C\u544A")), 1)) : (_openBlock(), _createElementBlock("article", _hoisted_13, _toDisplayString(_unref(groupProfile).notification), 1))])), _unref(isAuthorNotification) ? (_openBlock(), _createElementBlock("footer", _hoisted_14, [_unref(isEdit) ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        "class": "btn",
        onClick: updateProfile
      }, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u53D1\u5E03")), 1)) : (_openBlock(), _createElementBlock("button", {
        key: 1,
        "class": "btn",
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return isEdit.value = !_unref(isEdit);
        })
      }, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u7F16\u8F91")), 1))])) : _createCommentVNode("", true)])])]));
    };
  }
});